import { httpDomainClientService, httpDomainService } from "../http-service";

const getPersonelCrewTypes = async (objISearch: ISearch) => {
    const params = JSON.stringify({
      search: objISearch.search,
      sortBy: objISearch.sortBy,
      sortOrder: objISearch.sortOrder,
      filterBy: {
        columnName: objISearch.filterBy?.columnName,
        columnValue: objISearch.filterBy?.columnValue
      },
      paginationInfo: {
        perPage: objISearch.pagination?.perPage,
        page: objISearch.pagination?.page,
      },
    });
    const res = await httpDomainService.post<CrewTypeApiResponse>(
      "/crew_types/get",
      params,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
        },
      }
    );
    
    return res.data;
  };

  const getDomainLookupItems = async (searchStr:string='',lookupTypeId:string='') => {
    const name = "";
    const currentDate = new Date().toISOString().split("T")[0]; // Gets today's date dynamically
    const recNumber = 10000;
  
    const queryString = `search=${searchStr}&lookupTypeId=${lookupTypeId}&name=${encodeURIComponent(name)}&currentDate=${currentDate}&recNumber=${recNumber}`;
  
    const data = await httpDomainClientService.get<DomainApiResponse>(
      `/lookup/type/search?${queryString}`
    );
  
    return data;
  };

  const getDomainLookupTypes = async () => {
    const data = await httpDomainClientService.get<DomainLookupType>(
      `/lookup-type`
    );
  
    return data.data.items;
  };

 

export interface IPagination {
  perPage: number;
  page: number;
  totalPages?: number;
  total?: number;
}

export interface IPaginationResult<T> {
  status?: string;
  errorCodeId: string;
  errorMessage: string;
  paginationInfo: IPagination;
  data: T[];
}

export interface IAuditInfo {
  createUserId?: string;
  createTimestamp?: Date | string;
  updateUserId?: string;
  updateTimestamp?: Date | string;
}

 
export interface IForestArea {
  corporateRegionId: string[];
}

export interface IFilter {
  columnName: string;
  columnValue: string;
  reportDateFrom?: string | null;
  reportDateTo?: string | null;
  corporateRegions?: IForestArea;
  negotiated?: boolean;
}

export interface ISearch {
  serviceName?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  filterBy?: IFilter;
  pagination: IPagination;
}

 
export interface DomainLookupItem {
  id: number;
  description: string;
}

export interface DomainLookupType {
  id: number;
  name: string;
}

export interface FireNumberItem {
  id: number;
  fireNumber: string;
  year: number;
  carryOver: string;
}

export interface ICrewType extends IAuditInfo {
  crewTypeId: string;
  code: string;
  description: string;
  effectiveDate?: string;
  terminationDate?: string;
  sortOrder?: number;
  fdomNameId?: number;
  fDomCodeId?: number;
}

export interface ICorporateRegion extends IAuditInfo {
  corporateRegionId: string;
  crt_id: string;
  name: string;
  effective_date: string;
  termination_date?: string;
}

 

export interface FireNumberSearchRequest {
  search: string;
  year: string;
  paginationInfo: IPagination;
}
 
interface DomainApiResponse {
  status: string;
  errorCodeId: string;
  errorMessage: string;
  paginationInfo: IPagination;
  data: DomainLookupItem[];
}


export class DomainLookupType {
  items: DomainLookupType[];
  pageInfo: IPagination;

  constructor(data: any) {
    this.items = data?.data || [];
    this.pageInfo = data?.paginationInfo || { perPage: 0, page: 1, total: 0 };
  }
  
}

export type FireNumberApiResponse = IPaginationResult<FireNumberItem>;
export type CrewTypeApiResponse = IPaginationResult<ICrewType>;
export type DomainLookupApiResponse = IPaginationResult<DomainLookupItem>;



export const DomainService = {
  getPersonelCrewTypes,
  getDomainLookupItems,
  getDomainLookupTypes
};